import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getInfoRequired } from 'services/InfoRequiredService'

export const useGetInfoRequired = (customerReference: string) => {
  return useQuery({
    queryKey: reactQueryKeys.infoRequired(customerReference),
    queryFn: () => getInfoRequired(customerReference),
    enabled: !!customerReference,
  })
}
